export const isFileSharingAvailable =
  typeof navigator !== "undefined" && !!navigator.share && !!navigator.canShare;

const isShareAborted = (error: unknown) =>
  error instanceof DOMException && error.name === "AbortError";

export type ShareFileResult = "shared" | "aborted" | "failed";

// Opens the native share sheet for a file. "aborted" (user closed the
// sheet) is not a failure and must not surface an error to the user.
export const shareFile = async (file: File): Promise<ShareFileResult> => {
  if (!isFileSharingAvailable || !navigator.canShare({ files: [file] })) {
    return "failed";
  }

  try {
    await navigator.share({ files: [file] });
    return "shared";
  } catch (error) {
    return isShareAborted(error) ? "aborted" : "failed";
  }
};
